import { LanguageBadge } from '@components/common/LanguageBadge';
import type { KnowledgeArticleDTO } from '@conversed/rest/src/contracts/article-architect/article-architect.dto';
import { formatShortDate } from '@helpers/dateHelpers';
import type React from 'react';
import { ArticleCategoryBadge, ArticleSourceBadge } from '../ArticleBadges';
import { ArticleCardBody } from '../ArticleCardBody';

// Body-only component — the modal chrome (title bar, close button, backdrop) is
// provided by ModalContainer. Open via showModal('knowledge-article-read', article.title, article).
// Matches the visual style of KnowledgeArticleCard used in the review queue.
export const ArticleReadModal: React.FC<KnowledgeArticleDTO> = (article) => {
  const formattedDate = formatShortDate(article.createdAt);

  return (
    <div className='px-4 py-0 overflow-y-auto max-h-[65vh] custom-scrollbar'>
      <div>
        {formattedDate && (
          <p className='text-pico text-gray-400 mb-1'>{formattedDate}</p>
        )}

        {/* Badges — order: source, category, language (status not shown here) */}
        <div className='flex flex-wrap items-center gap-2 mb-4'>
          <ArticleSourceBadge article={article} />
          <ArticleCategoryBadge article={article} />
          <LanguageBadge language={article.language} />
        </div>

        <ArticleCardBody article={article} blockquoteText={article.subtitle} />
      </div>
    </div>
  );
};
